import { ISessionStreamer } from '@amzn/work-spaces-web-client-core-lib';

export class MaxibonSessionStreamer implements ISessionStreamer {
  streamWorkspace(props: any) {
    return '';
  }

  disconnect() {}

  changeResolution() {}

  sendCtrlAltDel() {}
}
